import { useEffect, useId } from 'react'
import { Container, Image } from 'react-bootstrap'
import Carousel from 'react-multi-carousel'
import LeftIcon from '@assets/icons/carousel-arrow-left.svg'
import RightIcon from '@assets/icons/carousel-arrow-right.svg'
import TeamCard, { TeamCardProps } from '@modules/teams/components/TeamCard/TeamCard'

import styles from './OurLeadership.module.scss'

export type Carousel1ResSizeBreakpointProps = {
    max: number
    min: number
}

export type Carousel1ResSizeProps = {
    breakpoint: Carousel1ResSizeBreakpointProps
    items: number
}

export type Carousel1ResProps = {
    superLargeDesktop: Carousel1ResSizeProps
    desktop: Carousel1ResSizeProps
    tablet: Carousel1ResSizeProps
    mobile: Carousel1ResSizeProps
    [key: string]: Carousel1ResSizeProps
}

const responsive: Carousel1ResProps = {
    superLargeDesktop: {
        // the naming can be any, depends on you.
        breakpoint: { max: 4000, min: 1200 },
        items: 4,
    },
    desktop: {
        breakpoint: { max: 1199.99, min: 992 },
        items: 4,
    },
    tablet: {
        breakpoint: { max: 991.99, min: 768 },
        items: 2,
    },
    mobile: {
        breakpoint: { max: 767.99, min: 0 },
        items: 1,
    },
}

const ButtonGroup = ({
    next,
    previous,
    length,
    ...rest
}: {
    next?: () => void
    previous?: () => void
    length: number
}) => {
    const {
        carouselState: { currentSlide, deviceType },
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } = rest as any
    return (
        <div className={styles.carouselButtonGroup}>
            {' '}
            <Image
                width={42}
                height={42}
                src={LeftIcon.src}
                alt="left arrow"
                className={(currentSlide === 0 ? styles.carouselDisabled : styles.carouselArrow, 'arrow-left')}
                onClick={() => previous && previous()}
            />
            <Image
                width={42}
                height={42}
                src={RightIcon.src}
                alt="right arrow"
                className={
                    (currentSlide + responsive[deviceType].items === length
                        ? styles.carouselDisabled
                        : styles.carouselArrow,
                    'arrow-right')
                }
                onClick={() => next && next()}
            />
        </div>
    )
}

export default function OurLeadership({ list }: { list: TeamCardProps[] }) {
    const key = useId()
    useEffect(() => {
        //lighthouse fix
        setTimeout(() => {
            const carouselItems = Array.from(document.getElementsByClassName('react-multi-carousel-item'))
            carouselItems
                .filter((el) => el.ariaHidden === 'true')
                .forEach((element) => {
                    const children = element.querySelectorAll('a')
                    children.forEach((child) => {
                        child.setAttribute('tabindex', '-1')
                    })
                })
        }, 2000)
    }, [])

    return (
        <Container>
            <section className="pt-3 pt-xl-6">
                <div className="OurLeadership position-relative">
                    <h2 className="h1 mb-lg-6">Our Leadership</h2>
                    <Carousel
                        responsive={responsive}
                        arrows={false}
                        infinite
                        renderButtonGroupOutside={true}
                        customButtonGroup={<ButtonGroup length={list.length} />}
                    >
                        {list &&
                            list.map((item: TeamCardProps, index: number) => (
                                <div className="m-5 m-md-4 m-lg-3" key={key + index}>
                                    <TeamCard item={item}></TeamCard>
                                </div>
                            ))}
                    </Carousel>
                </div>
            </section>
        </Container>
    )
}
